import { useProfile } from '@hooks/api';
import { useLoadingModal } from '@hooks/useLoadingModal';
import { accountStatus } from '@models/api/user/profile/profile';
import { linkClick, navClick } from '@services/analytics';
import { AnalyticsNavLocation, AnalyticsScreenName } from 'mh-client';
import { useIntl } from 'react-intl';
import NavLinksBase from '../../atoms/navbar/NavLinksBase';
import { links } from '../../organisms/navbar/NavBarLinksObj';
import './HeaderTitle.scss';

const NavLinks = ({ cytag }: { cytag?: string }) => {
    const intl = useIntl();
    const { data: userProfile, isLoading } = useProfile();
    const status = userProfile?.accountStatus?.name as
        | accountStatus
        | undefined;

    useLoadingModal(isLoading);

    if (!userProfile || !status) {
        return <></>;
    }

    return (
        <ul className="flex flex-col lg:flex-row lg:gap-x-4 gap-y-6">
            {links.map((link, index) => {
                if (!link.accountStatus.includes(status)) return null;

                const analytics = link.analytics;
                const onClick = () => {
                    if (analytics.event === 'nav') {
                        navClick({
                            screen_name: AnalyticsScreenName.getInstance().MENU,
                            nav_location:
                                AnalyticsNavLocation.getInstance().SIDE_MENU,
                            destination: analytics.destination,
                        });
                    } else {
                        linkClick({
                            screen_name: AnalyticsScreenName.getInstance().MENU,
                            link_id: analytics.linkId,
                            destination: analytics.destination,
                        });
                    }
                };

                return (
                    <NavLinksBase
                        leftIcon={link.icon}
                        to={link.url}
                        label={intl.formatMessage({ id: link.label })}
                        key={`${index}-${link.label}`}
                        id={`topNav_link_${link.label.toLowerCase()}`}
                        cy={`${cytag}_${link.label.toLowerCase()}`}
                        onClick={onClick}
                    />
                );
            })}
        </ul>
    );
};

export default NavLinks;
